module.exports = __webpack_public_path__ + "static/media/powerrecruiter.0fc34ecc.jpg";